import { render, staticRenderFns } from "./AssetRole.vue?vue&type=template&id=8ed8b662&scoped=true&"
import script from "./AssetRole.vue?vue&type=script&lang=js&"
export * from "./AssetRole.vue?vue&type=script&lang=js&"
import style0 from "./AssetRole.vue?vue&type=style&index=0&id=8ed8b662&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ed8b662",
  null
  
)

export default component.exports